//import { mainStyles } from '../../styles/Main.js'
import { withStyles } from '@mui/styles';
import { green, red } from '@mui/material/colors';
import { Typography,useTheme
} from '@mui/material'
import React, { useEffect, useState } from 'react';
// import { useStyles } from '../dynamicForm/DynamicFormStyles'
import { CustomCounterAppBar, CustomLoadingOverlay ,Buttons } from '../../components'
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Grid from '@mui/material/Grid';
import { Image } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom'

import axios from 'axios';
import { AppUrls, } from '../../services/Globals';
import { Config } from '../../services/Config';
import { useTranslation } from 'react-i18next';



export default function ValidacionesExternas(props) {

    const [currentStage, setCurrentStage] = useState(0)
    const [totalStage, setTotalStage] = useState(0)
    const [loadView, setLoadView] = useState(false)
    const [widthButton, setWidthButton] = useState(100)
    const localStyles = {}//useStyles()
     const theme = useTheme()
    const location = useLocation()
  const classes = {} //mainStyles.bodyStyles()
    const [lista, setLista] = useState();
    const [satEstado, setSatEstado] = useState();
    const [creditoEstado, setCreditoEstado] = useState();
    const [blacklist, setBlackList] = useState();
    const { t } = useTranslation();

    useEffect(() => {
        axios.post(
            AppUrls.DownloadDocument,
            Config.SetParameters('', '', '', ''),
            Config.ConfigAuth(sessionStorage.getItem('token'))
        )
    })



    const GreenCheckbox = withStyles({
        root: {
            color: red[400],
            '&$checked': {
                color: green[600],
                borderradius: 50,
            },

        },
        tableui: {
            margin: '2'
        },
        table: {
            flexGrow: 1,
        },

        checked: {},
    })((props) => <Checkbox color="default" {...props} />);

    return (
        <div className={localStyles.root}>
            <CustomLoadingOverlay active={loadView} text={t("general_loading_message")} />
            {/* <LoadingOverlay
                active={loadView}
                spinner
                text='Espere un momento por favor...'
                className={classes.loader}>
            </LoadingOverlay> */}
            <CustomCounterAppBar
                initialStep={currentStage}
                endingStep={totalStage} />

            <form onSubmit="" className={localStyles.formContainer}>
                <Typography variant="h6" gutterBottom className={localStyles.title}>Validaciones Externas </Typography>

                <div id='questionsContainer' className={localStyles.questionsContainer}>
                    <Grid container spacing={3}>
                        <Image style={{ marginLeft: 150 }}
                            src={'/validaciones.svg'}
                        />

                        <Typography>Tu Identidad ha sido verificada ante las siguientes instituciones:</Typography>
                        <Grid item xs={12} className={GreenCheckbox.tableui}>
                            <FormControlLabel
                                label=" Servicio de Administracion Tributaria"
                                control={<Image src={'/done.svg'} />}
                            />
                        </Grid>
                        <Grid item xs={12} className={GreenCheckbox.tableui}>
                            <FormControlLabel
                                label=" Sociedades de informacion crediticia"
                                control={<Image src={'/done.svg'} />}
                            />
                        </Grid>
                        <Grid item xs={12} className={GreenCheckbox.tableui}>
                            <FormControlLabel
                                label=" Listas negras"
                                control={<Image src={'/done.svg'} />}
                            />
                        </Grid>
                    </Grid>
                    <Buttons
                        className={localStyles.acceptBtn}
                        size={widthButton}
                        text_color='#FFFFFF'
                        background_color='#C20E30'
                        border_color='#C20E30'
                        text='Continuar'
                        type='submit' />
                </div>
            </form>
        </div>
    )


}
